import type { BrowserSession, DevelopmentSession } from "@lunavoa/contracts";
import { api } from "@lunavoa/api-client";

export const DEVELOPMENT_AUTH_NOTICE = "Development authentication — not a production identity system.";

export const developmentAuth = {
  session: () => api.get<DevelopmentSession>("/session"),
  startParentSession: () => api.post<DevelopmentSession>("/auth/parent-development"),
  startAdminSession: (accessKey: string) => api.post<DevelopmentSession>("/auth/admin-development", { accessKey }),
  logout: () => api.post<{ ok: true }>("/auth/logout"),
};

export const browserAuth = {
  session: () => api.get<BrowserSession>("/session"),
  login: (audience: "parent" | "admin") => api.post<{ authorizationUrl: string }>("/auth/login/google", { audience, returnPath: audience === "admin" ? "/admin" : "/app" }),
  logout: developmentAuth.logout,
  renew: () => api.post<{ ok: true }>("/auth/renew"),
  switchAccount: (accountId: string) => api.post<{ ok: true }>("/auth/account-context", { accountId }),
};
